import React from 'react';
import { Button, Drawer, IconButton, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
// Styles
import { Close, Delete } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import {
  set_delete_user_dialog,
  set_edit_user_drawer,
  set_user_details_drawer,
} from 'Store/reducers/adminReducer';
import { AppDispatch, RootState } from 'Store/Store';
import { EditIcon } from 'Components/Icons';

export const UserDetails: React.FC = (): React.ReactElement => {
  const dispatch = useDispatch<AppDispatch>();
  const user_details_drawer = useSelector(({ admin }: RootState) => admin.user_details_drawer);
  const user_details = useSelector(({ user }: RootState) => user.user_details);

  return (
    <Drawer
      BackdropProps={{ invisible: true }}
      anchor="right"
      open={user_details_drawer}
      sx={{ zIndex: theme => theme.zIndex.drawer + 2 }}>
      <Grid
        container
        direction="column"
        flexWrap="nowrap"
        justifyContent="space-between"
        sx={{ height: '100%' }}>
        <Grid container direction="column">
          <Grid container direction="row" justifyContent="flex-end" alignItems="center">
            <IconButton
              onClick={() => {
                dispatch(set_user_details_drawer(false));
              }}>
              <Close />
            </IconButton>
          </Grid>

          <Grid container direction="column" justifyContent="space-between" spacing={3}>
            <Grid>
              <Typography variant="h6" color="#FFF">
                User ID: {user_details?.id}
              </Typography>
            </Grid>

            <Grid>
              <Typography variant="h5" sx={{ color: '#FFF' }}>
                {user_details?.name}
              </Typography>
            </Grid>

            <Grid>
              <Typography variant="h6" color="#FFF" fontWeight={700}>
                Contact Details
              </Typography>
            </Grid>
            <Grid container direction="column" spacing={2}>
              <Grid container spacing={2} direction="row">
                <Grid size={4}>
                  <Typography variant="h6" color="#FFF">
                    Email:
                  </Typography>
                </Grid>
                <Grid size="grow">
                  <Typography variant="h5" textTransform="lowercase" color="#FFF">
                    {user_details?.email}
                  </Typography>
                </Grid>
              </Grid>

              <Grid container spacing={2} direction="row">
                <Grid size={4}>
                  <Typography variant="h6" color="#FFF">
                    Phone:
                  </Typography>
                </Grid>
                <Grid size="grow">
                  <Typography variant="h5" color="#FFF">
                    {user_details?.phone}
                  </Typography>
                </Grid>
              </Grid>

              <Grid container spacing={2} direction="row">
                <Grid size={4}>
                  <Typography variant="h6" color="#FFF">
                    Role:
                  </Typography>
                </Grid>
                <Grid size="grow">
                  <Typography variant="h5" color="#FFF">
                    {user_details?.role ? user_details?.role.display_name : ''}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container direction="column" spacing={2}>
          <Grid>
            <Button
              variant="contained"
              color="error"
              startIcon={<Delete />}
              onClick={() => dispatch(set_delete_user_dialog(true))}
              fullWidth
              sx={{
                '&:hover': {
                  background:
                    'linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), #FF4141',
                },
              }}>
              Delete User
            </Button>
          </Grid>
          <Grid>
            <Button
              fullWidth
              startIcon={<EditIcon />}
              variant="contained"
              color="secondary"
              onClick={() => dispatch(set_edit_user_drawer(true))}>
              Edit User
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Drawer>
  );
};

export default UserDetails;
